module.exports = __webpack_public_path__ + "static/media/3_Pre-Check-Doorbell-Size-Straight.cd34d4c0.svg";